import InputPhoneComponent from '@/common/components/InputPhoneComponent';
export default {
  name: "BuyWorkModal",
  components: {
    InputPhoneComponent
  },
  props: {
    options: {
      type: Object,
      default: () => ({
        dialog: {
          visible: false
        }
      })
    }
  },

  data() {
    return {
      result: {
        type: 'closed'
      },
      tel: '',
      email: '',
      name: '',
      error: '',
      agreePolicy: false
    };
  },

  methods: {
    handlerSuccess() {
      if (!this.tel) return this.error = 'Введите телефон';
      if (!this.email) return this.error = 'Введите Email';
      if (!this.name) return this.error = 'Введите Имя';
      if (!this.agreePolicy) return this.error = 'Подтвердите согласие с политикой обработки данных';
      this.error = '';
      this.result.type = 'success';
      this.result.data = {
        phone: this.tel,
        email: this.email,
        name: this.name
      };
      this.$store.dispatch('hideModal');
      this.$nextTick(() => {
        this.$store.dispatch('resultModal', this.result);
        this.tel = '';
        this.email = '';
        this.name = '';
      });
    },

    handlerClosed() {
      this.$store.dispatch('hideModal');
    }

  }
};